import * as React from 'react';
import { compose, withProps } from 'recompose';
import { reduxForm } from 'redux-form';
import { Prompt } from 'react-router';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { get } from 'lodash';
import { connect } from 'react-redux';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { Card } from 'material-ui/Card';

import { getActualDate } from '@utils/utils';
import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';
import { Tabs } from '@components/tabs';

import { WantedVehiclesFormSearch } from '@modules/wantedVehicles/WantedVehiclesFormSearch';
import { WantedVehiclesFormVehicle } from '@modules/wantedVehicles/WantedVehiclesFormVehicle';
import { WantedVehiclesFormOwner } from '@modules/wantedVehicles/WantedVehiclesFormOwner';
import { getWantedVehicle, defaultWantedVehicle } from '@modules/wantedVehicles/_wantedVehiclesActions';

import * as T from '@modules/wantedVehicles/_wantedVehiclesTypes';

export const enhance = compose<T.WantedVehiclesFormProps, T.Outter>(
  entityDetailEnhancer<T.WantedVehicleEnhancerProps<T.WantedVehicle> & Partial<T.WantedVehicle>, T.WantedVehicle>({
    getEntity: getWantedVehicle,
    defaultEntity: defaultWantedVehicle
  }),
  breadcrumbs(({ entity }) => [
    { label: 'Hledaná vozidla', to: '/wanted/vehicles' },
    { label: get(entity, 'vehicle.registrationNumber', 'Nové vozidlo') }
  ]),
  withProps<{}, T.WantedVehicleProps>(({ entity }) => ({
    initialValues: {
      reportedDate: getActualDate(),
      ...entity
    }
  })),
  reduxForm({}),
  connect()
);

export const View: React.SFC<T.Outter & T.WantedVehiclesFormProps> = ({
  handleSubmit,
  closeItem,
  dirty,
  submitSucceeded,
  submitting,
  form
}) => (
  <div>
    <Prompt when={dirty && !submitSucceeded && !submitting} message="Vaše změny nebyly uloženy, přesto odejít?" />
    <form className="layout" onSubmit={handleSubmit}>
      <Card>
        <Tabs
          items={[
            { label: 'Pátrání', style: { minWidth: 150 }, content: <WantedVehiclesFormSearch /> },
            { label: 'Vozidlo', style: { minWidth: 150 }, content: <WantedVehiclesFormVehicle form={form} /> },
            { label: 'Držitel', style: { minWidth: 150 }, content: <WantedVehiclesFormOwner form={form} /> }
          ]}
        />

        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </Card>
    </form>
  </div>
);

export const WantedVehiclesForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/wantedVehicles/WantedVehiclesForm.tsx